import { UserProfileTabBar as View } from 'ui-components'
import { useIsMyProfile } from '~user-profile/hooks/useIsMyProfile'
import { useGetCurrentUser } from '~user-profile/queries/useGetUserById'
import { useSearchMapsInCurrentUserProfile } from '~user-profile/queries/useSearchMaps'

const TabBar = () => {
  const isMyProfile = useIsMyProfile()

  const { isLoading: isMapsLoading, data: searchMapsData } =
    useSearchMapsInCurrentUserProfile()

  const { isLoading: isProfileLoading, data: user } = useGetCurrentUser()

  return (
    <View
      canUpdateUserSettings={isMyProfile}
      totalMaps={searchMapsData?.total || 0}
      totalWorkspaces={user?.membershipCollection?.total || 0}
      loading={isProfileLoading || isMapsLoading}
    />
  )
}

export { TabBar }
